import axios from "axios"

const STORAGE_KEY = 'contract_verification_status'

console.log('contract-verification module loaded')

export default {
  namespaced: true,
  state: {
    isVerifying: false,
    verificationResult: null,
    verificationError: null,
    pollingInterval: null,
    showVerificationModal: false,
    isPollingActive: false,
  },

  getters: {
    getIsVerifying: state => state.isVerifying,
    getVerificationResult: state => state.verificationResult,
    getVerificationError: state => state.verificationError,
    getShowVerificationModal: state => state.showVerificationModal,
    getIsPollingActive: state => state.isPollingActive,
  },

  actions: {
    saveContractStatusToStorage({ commit }, status) {
      const storageData = {
        status: status.approved ? 'approved' : 'not_approved',
        data: status.data,
        session_uuid: localStorage.getItem('session_uuid'),
        timestamp: Date.now()
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData))
      commit('setIsPollingActive', false)
    },

    restoreContractStatusFromStorage({ commit }) {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (!stored) return null

      try {
        const data = JSON.parse(stored)
        const currentSessionUuid = localStorage.getItem('session_uuid')

        if (data.session_uuid && data.session_uuid !== currentSessionUuid) {
          localStorage.removeItem(STORAGE_KEY)
          return null
        }

        const hourInMs = 60 * 60 * 1000
        if (Date.now() - data.timestamp > hourInMs) {
          localStorage.removeItem(STORAGE_KEY)
          return null
        }

        if (data.status === 'approved') {
          commit('setVerificationResult', { approved: true, data: data.data })
        } else if (data.status === 'under_analysis') {
          commit('setIsVerifying', true)
          commit('setIsPollingActive', true)
        }

        return data
      } catch (e) {
        localStorage.removeItem(STORAGE_KEY)
        return null
      }
    },

    clearContractStatusFromStorage() {
      localStorage.removeItem(STORAGE_KEY)
    },

    async startContractVerification({ commit }, sessionUuid) {
      commit('setIsVerifying', true)
      commit('setVerificationResult', null)
      commit('setVerificationError', null)
      commit('setIsPollingActive', true)

      localStorage.setItem(STORAGE_KEY, JSON.stringify({ status: 'under_analysis', session_uuid: sessionUuid, timestamp: Date.now() }))

      const pollingInterval = setInterval(async () => {
        console.log('🔄 Polling executando...', new Date().toLocaleTimeString())
        
        try {
          const response = await axios.get(`/contract/${sessionUuid}/verify`)
          const { data } = response
          
          console.log('📦 Resposta do polling:', data)

          if (data.under_analysis === true) {
            console.log('⏳ Ainda em análise...')
            return
          }

          if (data.under_analysis === false) {
            const approved = data.approved === true
            console.log('✅ Análise finalizada:', approved ? 'APROVADO' : 'REPROVADO')

            commit('setVerificationResult', { approved, data })
            commit('setIsVerifying', false)
            commit('setShowVerificationModal', true)
            commit('setIsPollingActive', false)

            this.dispatch('contractVerification/saveContractStatusToStorage', { approved, data })

            clearInterval(pollingInterval)
            commit('setPollingInterval', null)
          }
        } catch (error) {
          console.error('❌ Erro no polling:', error)
          commit('setVerificationError', error)
          commit('setIsVerifying', false)
          commit('setShowVerificationModal', true)
          commit('setIsPollingActive', false)

          clearInterval(pollingInterval)
          commit('setPollingInterval', null)
          this.dispatch('contractVerification/clearContractStatusFromStorage')
        }
      }, 10000)

      commit('setPollingInterval', pollingInterval)
    },

    stopContractVerification({ commit, state }) {
      if (state.pollingInterval) {
        clearInterval(state.pollingInterval)
        commit('setPollingInterval', null)
      }
      commit('setIsVerifying', false)
    },

    closeVerificationModal({ commit }) {
      commit('setShowVerificationModal', false)
      commit('setVerificationResult', null)
      commit('setVerificationError', null)
    },

    resetVerification({ commit }) {
      commit('setIsVerifying', false)
      commit('setVerificationResult', null)
      commit('setVerificationError', null)
      commit('setShowVerificationModal', false)
    }
  },

  mutations: {
    setIsVerifying: (state, value) => {
      state.isVerifying = value
    },

    setVerificationResult: (state, result) => {
      state.verificationResult = result
    },

    setVerificationError: (state, error) => {
      state.verificationError = error
    },

    setShowVerificationModal: (state, value) => {
      state.showVerificationModal = value
    },

    setPollingInterval: (state, interval) => {
      state.pollingInterval = interval
    },

    setIsPollingActive: (state, value) => {
      state.isPollingActive = value
    }
  }
}
